import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartScatter({ data, xKey, yKey, labelKey, titleX, titleY }) {
  const series = useMemo(
    () =>
      data.map((item) => ({
        name: item[labelKey],
        data: [{ x: item[xKey], y: item[yKey] }],
      })),
    [data, xKey, yKey, labelKey]
  );

  const options = useMemo(
    () => ({
      chart: { type: "scatter", zoom: { enabled: false } },
      dataLabels: {
        enabled: true,
        formatter: (_, opts) => opts.w.config.series[opts.seriesIndex].name,
        style: { colors: ["var(--text-50)"] },
        offsetY: -8,
      },
      xaxis: {
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      legend: { show: false },
      tooltip: {
        custom: ({ seriesIndex, w }) => {
          const s = w.config.series[seriesIndex];
          return `<div style="padding:6px 10px"><b>${s.name}</b><br/>${titleX}: ${s.data[0].x}<br/>${titleY}: ${s.data[0].y}</div>`;
        },
      },
    }),
    [titleX, titleY]
  );

  return (
    <Chart options={options} series={series} type="scatter" height="100%" width="100%" />
  );
}

export default memo(ChartScatter);
